//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LoadingButton from '@/components/ui/LoadingButton'
import FreelancersSearchItem from '@/components/client/FreelancersSearchItem'
import TextareaGroup from '@/components/form/TextareaGroup'
import InputGroup from '@/components/form/InputGroup'
import AxiosErrorHandler from '@/mixins/AxiosErrorHandler'
import { required } from 'vuelidate/lib/validators'
import { taskStatuses } from 'ct-constants'

export default {
  name: 'InviteToJobForm',
  components: {
    LoadingButton,
    FreelancersSearchItem,
    TextareaGroup,
    InputGroup
  },
  mixins: [AxiosErrorHandler],
  props: {
    freelancer: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      form: {
        job: null,
        letter: null
      },
      inviting: false,
      loadingTasks: false,
      tasks: []
    }
  },
  validations: {
    form: {
      job: {
        required
      },
      letter: {
        required
      }
    }
  },
  computed: {
    /**
     * List of tasks for dropdown
     * @return {{text: *, value: string}[]}
     */
    publishedTasks () {
      return (this.tasks || []).filter(t => (t.published && (t.status === taskStatuses.ACCEPTING || t.status === taskStatuses.CREATED)))
        .map(t => ({
          text: t.title,
          value: `${t.id}`
        }))
    },
    skills () {
      return this.freelancer?.skills ? this.freelancer.skills.map(s => s.id) : []
    },

    isClient () {
      return this.$store.getters['user/isClient']
    },

    isAgent () {
      return this.$store.getters['user/isAgent']
    }
  },
  mounted () {
    if (this.isClient) {
      this.getClientsTasks()
    }

    if (this.isAgent) {
      this.getAgentsTasks()
    }
  },
  methods: {
    /**
     * Get tasks that client created
     * @returns {Promise<void>}
     */
    async getClientsTasks () {
      try {
        this.loadingTasks = true
        if (this.$auth.loggedIn) {
          const { data } = await this.$axios.get('/tasks/my', {
            params: {
              all: true
            }
          })
          this.tasks = data.data
        }
        this.loadingTasks = false
      } catch (err) {
        await this.handleError(err)
        this.loadingTasks = false
      }
    },

    /**
     * Get tasks assigned to agent
     * @returns {Promise<void>}
     */
    async getAgentsTasks () {
      try {
        this.loadingTasks = true
        if (this.$auth.loggedIn) {
          const { data } = await this.$axios.get('/agents/tasks', {
            params: {
              all: true
            }
          })
          this.tasks = data.data
        }
        this.loadingTasks = false
      } catch (err) {
        await this.handleError(err)
        this.loadingTasks = false
      }
    },

    /**
     * Invite freelancer
     * @returns {Promise<void>}
     */
    async invite () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.inviting = true
        try {
          await this.$axios.post('/invitations', {
            taskId: this.form.job,
            freelancerId: this.freelancer.id,
            letter: this.form.letter
          })
          const task = this.tasks.find(t => t.id === parseInt(this.form.job, 10))
          this.$emit('invited', task)

          await this.$store.dispatch('ui/showNotification', {
            type: 'success',
            text: this.$t('freelancers.invitation_success_message')
          })

          // end loading
          this.inviting = false

          // reset form data
          this.form = {
            job: null,
            letter: null
          }
          // reset form validation
          this.$v.$reset()
        } catch (err) {
          await this.handleError(err)
          this.inviting = false
        }
      }
    }
  }
}
